// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3FT6H","unreadBadge":"styles_unreadBadge__1yjhZ","modalContent":"styles_modalContent__nh-xA","modal":"styles_modal__3UT9-"};